import * as actionTypes from './actionTypes';
import axios from 'axios';
import {format, parse} from "date-fns";
export const bookingListSet = (urlHospitalId, urlStatus, urlKeyword, urlDate, urlPage, urlSortColumn, urlSortMode) => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.LOADING_START});

        const hospitalId = getState().auth.selectedHospital.id;
        const {status, keyword, filter, page, sortColumn, sortMode, date } = getState().bookingList;
        if (urlKeyword && (keyword !== urlKeyword)) {
            dispatch({type: actionTypes.BOOKING_LIST_SET_KEYWORD, keyword: urlKeyword, date: urlDate, status: urlStatus, sortColumn: urlSortColumn, sortMode: urlSortMode })
        } else {
            dispatch({type: actionTypes.BOOKING_LIST_SET_STATUS, status: urlStatus, date: urlDate, sortColumn: urlSortColumn, sortMode: urlSortMode})
        }

        dispatch(bookingListReload());

        // } else if (urlStatus &&  (status !== urlStatus)) {
        //     console.log('[action/bookingList] dispatching status from url', urlStatus);
        //     dispatch({type: actionTypes.BOOKING_LIST_SET_STATUS, status})
        // } else {
        //     dispatch(bookingListReload());
        // }
    }
};

export const bookingListReload = () => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.LOADING_START});

        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;
        const {status, keyword, date, page, sortColumn, sortMode } = getState().bookingList;

        let apiEndpoint = '';
        apiEndpoint = `/bookings/${hospitalId}?status=${status ?? 'active'}`;

         if (keyword) {
            apiEndpoint += `&search=${keyword}`;
        }

        if (sortColumn) {
            apiEndpoint += `&sortColumn=${sortColumn}`;
        }

        if (sortMode) {
            apiEndpoint += `&sortMode=${sortMode}`;
        }

        if (date) {
            apiEndpoint += `&date=${date}`;
        }

        axios.get(
            apiEndpoint,
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                dispatch({type: actionTypes.BOOKING_LIST_SET, ...response.data})
                dispatch({type: actionTypes.LOADING_DONE});
            }).catch((error) => {
                console.error("Error fetching booking list:", error);
                dispatch({ type: actionTypes.LOADING_DONE });
            });
        ;
    }
};

export const openBookingEventLogsModal = (booking) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;

        dispatch({type: actionTypes.MODAL_BOOKING_EVENT_LOGS_SHOW, booking});

        axios.get(
            `/bookings/${hospitalId}/${booking.id}/event-logs`,
            {headers: {'Authorization': idToken}}
        ).then((response) => {
            dispatch({
                type: actionTypes.MODAL_BOOKING_EVENT_LOGS_SET,
                logs: response.data.logs || [],
                logs_eventTypes: response.data.logs_eventTypes || {},
            });
        }).catch(() => {
            dispatch({type: actionTypes.MODAL_BOOKING_EVENT_LOGS_SET, logs: [], logs_eventTypes: {}});
        });
    }
}

export const openBookingSmsModal = (booking) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;

        axios.get(
            `/bookings/${hospitalId}/${booking.id}/sms-preview`,
            {headers: {'Authorization': idToken}}
        ).then((response) => {
            dispatch({
                type: actionTypes.MODAL_BOOKING_SMS_SHOW,
                booking,
                preview: response.data.message || '',
            });
        }).catch(() => {
            dispatch({
                type: actionTypes.MODAL_BOOKING_SMS_SHOW,
                booking,
                preview: '',
            });
        });
    }
}

export const sendBookingSms = (booking, type, customMessage, addToast) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;

        dispatch({type: actionTypes.BOOKING_SMS_SEND_START, id: booking.id});

        axios.post(
            `/bookings/${hospitalId}/${booking.id}/send-sms`,
            {type, customMessage},
            {headers: {'Authorization': idToken}}
        ).then((response) => {
            dispatch({type: actionTypes.BOOKING_SMS_SEND_DONE, id: booking.id});
            if (response.data.done) {
                dispatch({type: actionTypes.BOOKING_REPLACE, booking: response.data.booking});
                dispatch({type: actionTypes.MODAL_BOOKING_SMS_HIDE});
                addToast('SMS sent', {appearance: 'success', autoDismiss: true});
            } else {
                addToast(response.data.message || 'Failed to send SMS', {appearance: 'error', autoDismiss: false});
            }
        }).catch((error) => {
            dispatch({type: actionTypes.BOOKING_SMS_SEND_DONE, id: booking.id});
            const msg = error.response?.data?.message || 'Failed to send SMS';
            addToast(msg, {appearance: 'error', autoDismiss: false});
        });
    }
}

// Booking List "PA" column: load pre-admission candidates around the booking's procedure date from the
// remote integration, so the manager can manually pick and link one to the booking.
export const loadBookingPreAdmissionHistory = (booking, customUiId) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;

        return axios.get(
            `/bookings/${hospitalId}/${booking.id}/pre-admission/${customUiId}/history`,
            {headers: {'Authorization': idToken}}
        ).then((response) => response.data);
    }
}

export const linkBookingPreAdmission = (booking, preAdmissionId, addToast) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;

        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: booking.id});

        return axios.post(
            `/bookings/${hospitalId}/${booking.id}/pre-admission/${preAdmissionId}`,
            {},
            {headers: {'Authorization': idToken}}
        ).then((response) => {
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: booking.id});
            if (response.data.done) {
                // Merge only preAdmission_id so the row keeps its already-loaded files.
                dispatch({type: actionTypes.BOOKING_REPLACE, booking: {id: booking.id, preAdmission_id: response.data.booking.preAdmission_id}});
                dispatch({type: actionTypes.MODAL_BOOKING_PRE_ADMISSION_SET_HIDE});
                if (addToast) addToast('Pre-admission linked', {appearance: 'success', autoDismiss: true});
            } else if (addToast) {
                addToast(response.data.error || 'Failed to link pre-admission', {appearance: 'error', autoDismiss: false});
            }
        }).catch((error) => {
            dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: booking.id});
            if (addToast) addToast('Failed to link pre-admission', {appearance: 'error', autoDismiss: false});
        });
    }
}

export const updateBookingStatus = (booking, addToast, status) => {
    return (dispatch, getState) => {
        const idToken = getState().auth.idToken;
        const hospitalId = getState().auth.selectedHospital.id;
        dispatch({type: actionTypes.RELOADING_PROGRESS_START, id: booking.id});

        axios.post(
            `/bookings/${hospitalId}/${booking.id}/status`,
            {status},
            {headers: {'Authorization': idToken}}
        )
            .then((response) => {
                console.log('[action/booking] updateBookingStatus response', response.data);

                if (response.data.done) {
                    addToast(`Booking has been successfully updated`, {
                        appearance: 'success',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: booking.id});
                    dispatch({type: actionTypes.BOOKING_UPDATE, booking: response.data.booking, 'counters': response.data.counters});
                } else {
                    addToast(`Failed to update the booking - ${response.data.error}`, {
                        appearance: 'error',
                        autoDismiss: false
                    });
                    dispatch({type: actionTypes.RELOADING_PROGRESS_DONE, id: booking.id});
                }
            });
    }
}